module.exports = __webpack_public_path__ + "static/media/diana.d564d25f.jpg";